import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { EmailsInputComponent } from '@shared/components/emails-input/emails-input.component';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

@Component({
  templateUrl: './client-add-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, EmailsInputComponent, TuiButton],
})
export class ClientAddUserComponent {
  private readonly context = inject<TuiDialogContext<string[], void>>(POLYMORPHEUS_CONTEXT);

  userMails: string[] = [];

  close(): void {
    this.context.completeWith([]);
  }

  addUser(): void {
    this.context.completeWith(this.userMails);
  }
}
